const o = "var(--gray-100)", x = {
  "2xl": {
    fontSize: "24px",
    borderRadius: "8px",
    pixelSize: 64
  },
  xl: {
    fontSize: "20px",
    borderRadius: "8px",
    pixelSize: 56
  },
  lg: {
    fontSize: "20px",
    borderRadius: "8px",
    pixelSize: 48
  },
  md: {
    fontSize: "16px",
    borderRadius: "8px",
    pixelSize: 40
  },
  sm: {
    fontSize: "14px",
    borderRadius: "6px",
    pixelSize: 32
  },
  xs: {
    fontSize: "12px",
    borderRadius: "4px",
    pixelSize: 24
  },
  "2xs": {
    fontSize: "8px",
    borderRadius: "2px",
    pixelSize: 16
  },
  "3xs": {
    fontSize: "6px",
    borderRadius: "1.25px",
    pixelSize: 10
  }
}, r = Object.fromEntries(
  Object.entries(x).map(([i, e]) => [
    i,
    {
      fontSize: e.fontSize,
      borderRadius: e.borderRadius,
      color: o
    }
  ])
), p = (i) => {
  var e;
  return ((e = x[i]) == null ? void 0 : e.pixelSize) || 40;
};
export {
  r as avatarTextSizes,
  p as getSizeStyles
};
